<template>
  <div>
    <h1 @click="toggleDescription">My Shop</h1>
    <p class="mb-2 text-muted">
      On this site, you can add products to the cart by clicking the
      <strong>+</strong>
      icon. The selected items will appear in your cart and can also be removed.
    </p>
    <p class="text-muted">
      You can also filter products by price using the slider. To show the slider, click the
      <strong>dollar icon ($)</strong>
      at the top right corner.
    </p>
    <p v-if="showDescription" class="mb-3 text-info">
      Made by Gilang Abdian using Vue.js 2. I just learned how to build this with Codepolitan. Codepolitan is an online
      platform for learning to code. This project is quite dizzying and almost made me want to vomit. LMAO.
    </p>
    <navbar
      :cart="cart"
      :cartQty="cartQty"
      :cartTotal="cartTotal"
      @toggle-slide="toggleSlider"
      @delete-item="deleteItem"
    ></navbar>
    <price-slider :sliderStatus="sliderStatus" :maximum.sync="maximum"></price-slider>
    <product-list :products="products" :maximum="maximum" @add-item="addItem"></product-list>
  </div>
</template>

<script>
import Navbar from './Navbar.vue';
import PriceSlider from './PriceSlider.vue';
import ProductList from './ProductList.vue';

export default {
  name: 'products',
  props: [
    'products',
    'maximum',
    'cart',
    'cartQty',
    'cartTotal',
    'sliderStatus',
    'sliderState',
    'showDescription',
    'hover'
  ],
  components: {
    Navbar,
    PriceSlider,
    ProductList
  },
  methods: {
    toggleDescription: function () {
      this.$emit('toggle-description');
    },
    toggleSlider: function () {
      this.$emit('toggle');
    },
    addItem: function (item) {
      this.$emit('add', item);
    },
    deleteItem: function (index) {
      this.$emit('delete', index);
    }
  }
};
</script>
